import type { CourseModule } from "@/core/types";
import { lektionRegeln } from "./lektion-01-regeln";
import { lektionVisuell } from "./lektion-02-visuell";

export const modulBedingteFormatierung: CourseModule = {
  id: "bedingte-formatierung",
  title: "Bedingte Formatierung",
  summary:
    "Eine Farbe, die aus dem Wert folgt statt an der Zelle zu kleben – und die " +
    "Grenze, ab der Farbe zur Behauptung wird.",
  level: "Aufbau",
  lessons: [lektionRegeln, lektionVisuell],
};
